var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginRightCorner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 243,
    viewBox: "0 0 172 243",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7576 -98.3988C35.8912 -97.0116 29.3676 -94.278 23.5635 -90.3558C17.7593 -86.4335 12.7896 -81.4004 8.94132 -75.547C-21.7877 -29.8114 35.3737 -6.25937 50.0301 31.6149C66.628 74.5815 30.6474 113.395 48.7411 155.2C63.8431 190.066 90.4346 192.994 123.105 204.802C149.267 214.255 174.824 250.951 204.805 241.085C256.874 223.898 227.228 168.121 209.691 139.238C193.204 112.185 185.2 81.472 183.863 49.9155C182.479 16.6084 189.481 -12.9908 168.634 -42.59C147.151 -72.9371 86.4403 -107.947 42.7576 -98.3988Z",
    fill: "#EE3343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRightCorner);
export default __webpack_public_path__ + "static/media/login-right-corner.a4606127f4fdb0888d50dfae46baebce.svg";
export { ForwardRef as ReactComponent };